module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Piano.b4b9e70c.png";